module.exports = __webpack_public_path__ + "img/flixmedia.a432b3fa.svg";